document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".wans-slider-wrapper").forEach((wrapper) => {

    const carousel = wrapper.querySelector(".wans-carousel");
    const prev = wrapper.querySelector(".wans-prev");
    const next = wrapper.querySelector(".wans-next");

    if (!carousel || !prev || !next) return;

    const getScrollAmount = () => {
      const card = carousel.querySelector(".wans-card");
      if (!card) return 300;
      return card.offsetWidth + 20;
    };

    prev.addEventListener("click", () => {
      carousel.scrollBy({
        left: -getScrollAmount() * 2,
        behavior: "smooth"
      });
    });

    next.addEventListener("click", () => {
      carousel.scrollBy({
        left: getScrollAmount() * 2,
        behavior: "smooth"
      });
    });

  });

});